export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9088.4866c5b5.jpg";